function initSwiper() {
    const swiper = new Swiper(".swiper", {
        // Optional parameters
        direction: "horizontal",
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
                centeredSlides: true,
                loop: true,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: true,
                centeredSlides: true,
            },
            800: {
                slidesPerView: 4,
                spaceBetween: 30,
                loop: true,
                centeredSlides: true,
            },
            1000: {
                slidesPerView: 4,
                spaceBetween: 60,
                centeredSlides: false,
            },
        },
    });
}

document.addEventListener("DOMContentLoaded", function (event) {
    initSwiper();
});
